import { ChangeDetectionStrategy, Component, DestroyRef, inject, input, OnInit, signal, DOCUMENT } from '@angular/core';
import { SessionService } from '@app/core/session/session.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LoggerService } from '@app/core/logger.service';
import { EMPTY, filter, Observable, take, catchError, tap, switchMap } from 'rxjs';
import { AlertComponent } from '@app/shared/components/alert/alert.component';
import { TranslatePipe } from '@ngx-translate/core';
import { SettingsService } from '@app/core/settings/settings.service';
import { ButtonComponent } from '@app/shared/branded-components/button/button.component';

@Component({
  selector: 'app-oidc-login',
  imports: [
    AlertComponent,
    TranslatePipe,
    ButtonComponent,
  ],
  templateUrl: 'oidc-login.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OidcLoginComponent implements OnInit {
  public redirect = input<string | undefined>();
  protected loginError = signal(false);
  private sessionService = inject(SessionService);
  private destroyRef = inject(DestroyRef);
  private logger = inject(LoggerService);
  private document = inject(DOCUMENT);
  private readonly hasAdditionalIndexHtml$ = inject(SettingsService).getHasAdditionalIndexHtml();

  public ngOnInit(): void {
    this.hasAdditionalIndexHtml$.pipe(
      take(1),
      filter(hasAdditionalIndexHtml => !hasAdditionalIndexHtml),
      switchMap(() => this.initializeLogin())
    ).subscribe();
  }

  protected logIn(): void {
    this.initializeLogin().subscribe();
  }

  private initializeLogin(): Observable<never> {
    return this.sessionService.startSignInFlow({
      redirectUrl: this.redirect(),
    }).pipe(
      takeUntilDestroyed(this.destroyRef),
      tap(url => this.document.location.href = url),
      switchMap(() => EMPTY),
      catchError((e) => {
        this.logger.logError(e);
        this.loginError.set(true);
        return EMPTY;
      }),
    );
  }
}
